import styled from 'styled-components';
import QuoteOpen from 'images/QuoteOpen.svg?react';
import { SColumn } from 'styles/layout';

export const SWrapper = styled(SColumn)`
    margin-top: 17rem;
    margin-bottom: 15rem;
    justify-content: center;
    text-align: center;

    > div {
        position: relative;
    }
`;

export const SQuoteOpen = styled(QuoteOpen)`
    position: absolute;
    top: -11rem;
    left: 0;
`;

export const SQuoteClose = styled(QuoteOpen)`
    position: absolute;
    bottom: -11rem;
    right: 0;
    transform: rotate(180deg);
`;

export const SQuoteContentWrapper = styled.div`
    max-width: 70%;
    margin: auto;
    color: ${({ theme }) => theme.color.secondary.main};
`;
